import { motion } from 'framer-motion';
import Card from '../components/Card'; // Motion'lı kartımız (eğer kullanılıyorsa) veya motion.div
import labInfo from '../data/labInfo';

// Liste elemanları için animasyon varyantları
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

export default function Lab() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-5xl md:text-6xl font-serif font-bold text-navy mb-4 tracking-tight"
          >
            Araştırma Laboratuvarı
          </motion.h1>
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: "6rem" }}
            transition={{ duration: 0.8 }}
            className="w-24 h-1 bg-gradient-to-r from-transparent via-navy to-transparent mx-auto mb-4"
          ></motion.div>
        </div>

        {/* Lab Overview */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-xl border-2 border-gray-200 p-8 mb-8 hover:shadow-xl transition-all duration-300"
        >
          <h2 className="text-3xl font-serif font-bold text-navy mb-4">{labInfo.name}</h2>
          <p className="text-gray-600 mb-4 text-lg">📍 {labInfo.location}</p>
          <p className="text-gray-700 leading-relaxed text-lg">{labInfo.description}</p>
        </motion.div>

        {/* Equipment - Stagger Grid */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-xl border-2 border-gray-200 p-8 mb-8 hover:shadow-xl transition-all duration-300"
        >
          <h2 className="text-2xl font-serif font-bold text-navy mb-6 pb-3 border-b border-gray-200">Laboratuvar Ekipmanları</h2>
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            {labInfo.equipment.map((item, index) => (
              <motion.div 
                key={index} 
                variants={itemVariants}
                whileHover={{ scale: 1.02, x: 5 }}
                className="flex items-center gap-3 p-4 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <span className="text-2xl">🔬</span>
                <span className="text-gray-700 font-medium">{item}</span>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

        {/* Research Areas */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-xl border-2 border-gray-200 p-8 mb-8 hover:shadow-xl transition-all duration-300"
        >
          <h2 className="text-2xl font-serif font-bold text-navy mb-6 pb-3 border-b border-gray-200">Araştırma Alanları</h2>
          <div className="flex flex-wrap gap-3">
            {labInfo.researchAreas.map((area, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ scale: 1.05, backgroundColor: "#1a237e" }} // Darker navy
                className="px-5 py-2.5 bg-navy text-white rounded-lg text-sm font-medium transition-colors cursor-default"
              >
                {area}
              </motion.span>
            ))}
          </div>
        </motion.div>

        {/* Contact */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-xl border-2 border-gray-200 p-8 hover:shadow-xl transition-all duration-300"
        >
          <h2 className="text-2xl font-serif font-bold text-navy mb-6 pb-3 border-b border-gray-200">İletişim</h2>
          <div className="space-y-4 text-gray-700">
            <div className="flex items-start gap-3">
              <span className="font-semibold text-navy min-w-[80px]">E-posta:</span>
              <a href={`mailto:${labInfo.contact.email}`} className="text-navy hover:underline">
                {labInfo.contact.email}
              </a>
            </div>
            <div className="flex items-start gap-3">
              <span className="font-semibold text-navy min-w-[80px]">Oda:</span>
              <span>{labInfo.contact.room}</span>
            </div>
            <div className="flex items-start gap-3">
              <span className="font-semibold text-navy min-w-[80px]">Bina:</span>
              <span>{labInfo.contact.building}</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}